var map = {
	"./docs-booking.png": 54,
	"./docs-mysite.png": 996,
	"./docs-proj-1.png": 732,
	"./docs-proj-2.png": 663,
	"./docs-proj-3.png": 166,
	"./docs-proj-4.png": 649,
	"./docs-proj-5.png": 520,
	"./docs-soundscene.png": 352,
	"./docs-throwmaster.png": 333,
	"./favicon.png": 657,
	"./github.svg": 443,
	"./gmail.svg": 656,
	"./og-img.png": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;